import styled from 'styled-components';

export const PageScrollProgressBarStyles = styled.div`
	width: 100%;
	height: 4px;
	background-color: ${({ theme }) => theme.v3.colors.gray[0]};

	.bar {
		height: 100%;
		background-color: ${({ theme }) => theme.v3.colors.blue[6]};
	}
`;
